import { useEffect, useState } from 'react';

// Janela do cupom BLACKHOF15 no Shopify (20 a 30/11/2026, horário de Brasília).
export const BLACK_FRIDAY_START = '2026-11-20';
export const BLACK_FRIDAY_END = '2026-11-30';
export const BLACK_FRIDAY_CODE = 'BLACKHOF15';

const brasiliaDay = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Sao_Paulo',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export function isBlackFridayInBrasilia(date = new Date()): boolean {
  const day = brasiliaDay.format(date); // YYYY-MM-DD
  return day >= BLACK_FRIDAY_START && day <= BLACK_FRIDAY_END;
}

/** Mesmo padrão do useOctoberRosa: false na hidratação, data real no efeito, refresh à meia-noite de Brasília. */
export function useBlackFriday(): boolean {
  const [active, setActive] = useState(() =>
    typeof window === 'undefined' || (window as any).__NATHOF_HYDRATING__ ? false : isBlackFridayInBrasilia(),
  );

  useEffect(() => {
    (window as any).__NATHOF_HYDRATING__ = false;
    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      clearTimeout(timer);
      const now = new Date();
      setActive(isBlackFridayInBrasilia(now));
      const nextMidnight = new Date(now);
      nextMidnight.setUTCHours(3, 0, 0, 0);
      if (nextMidnight.getTime() <= now.getTime()) {
        nextMidnight.setUTCDate(nextMidnight.getUTCDate() + 1);
      }
      timer = setTimeout(refresh, nextMidnight.getTime() - now.getTime());
    };
    refresh();
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('focus', refresh);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, []);

  return active;
}
